import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'fb-basic-modal',
    templateUrl: './basic-modal.component.html',
    styles: [],
})
export class BasicModalComponent implements OnInit {
    constructor(@Inject(MAT_DIALOG_DATA) public data: { title: string; message: string }, public dialogRef: MatDialogRef<BasicModalComponent>) {}

    ngOnInit(): void {}
}
